<template>
  <section class="bodypad" :class="success ? 'd-flex' : ''">
    <SuccessBillMessage
      v-if="success"
      :style="success ? 'overflow: hidden' : ''"
    />
    <v-row v-else class="mt-4 mb-10 d-flex flex-column">
      <h6 class="text-h6 text-md-h5 font-weight-bold mb-6">Facturación</h6>
      <div class="left-col">
        <v-alert
          v-if="hasError && showErrorMessage"
          dense
          type="error"
          icon="report"
        >
          El total de la factura no coincide con el indicado, revisá que el
          monto sea el correcto y volvé a subirla.
        </v-alert>
        <form @submit.prevent="handleSumbit">
          <component
            :is="currentStepComponent"
            :formData="formData"
            :v="$v.formData"
            @updateFile="setInvoiceFile"
          />

          <section class="d-flex flex-column" style="row-gap: 1rem">
            <v-btn
              depressed
              large
              block
              type="button"
              v-if="currentStep !== steps.length - 1"
              @click="nextStep"
              class="blue darken-2 white--text"
            >
              Siguiente
            </v-btn>

            <v-btn
              depressed
              large
              block
              :loading="sendFormLoading"
              type="submit"
              v-if="currentStep === steps.length - 1 && !$v.formData.$invalid"
              color="success"
            >
              Enviar
            </v-btn>

            <v-btn
              text
              large
              block
              type="button"
              v-if="currentStep > 0"
              @click="currentStep--"
              color="blue darken-2"
              >Anterior</v-btn
            >
          </section>
        </form>
      </div>
    </v-row>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import FirstStep from "../components/Form/steps/FirstStep.vue";
import SecondStep from "../components/Form/steps/SecondStep.vue";
import ThirdStep from "../components/Form/steps/ThirdStep.vue";
import SuccessBillMessage from "../components/SuccessBillMessage.vue";
import { required, minLength } from "vuelidate/lib/validators";

const WRONG_INVOICE = "illegible_bill";
const WRONG_AMOUNTS = "mismatched_amount";

export default {
  components: { FirstStep, SecondStep, ThirdStep, SuccessBillMessage },
  data: () => ({
    currentStep: 0,
    steps: [FirstStep, SecondStep, ThirdStep],
    success: false,
    hasError: false,
    showErrorMessage: false,
    sendFormLoading: false,
  }),
  mounted() {
    this.checkForTransactionsInStorage();
  },
  computed: {
    ...mapState("invoice", ["formData"]),
    ...mapGetters("invoice", ["formDataTransactions"]),

    currentStepComponent() {
      return this.steps[this.currentStep];
    },
  },
  validations: {
    formData: {
      transactions: { required, minLength: minLength(1) },
      cbu: { required },
      invoice: { required },
    },
  },
  methods: {
    ...mapActions("invoice", [
      "setInvoiceFile",
      "handleFormDataChanges",
      "sendInvoice",
      "resetStore",
    ]),
    ...mapMutations("invoice", ["setState"]),

    checkForTransactionsInStorage() {
      const storageTransactions = localStorage.getItem("pending-transactions");
      const parsedTransactions = storageTransactions
        ? JSON.parse(storageTransactions)
        : [];

      const draft = structuredClone(this.formData);
      if (parsedTransactions) {
        draft.transactions = parsedTransactions;
      }

      this.handleFormDataChanges(draft);
    },
    nextStep() {
      if (this.currentStep === 0) {
        this.$v.formData.transactions.$touch();
        if (this.$v.formData.transactions.$invalid) return;
      }
      if (this.currentStep === 1) {
        this.$v.formData.cbu.$touch();
        if (this.$v.formData.cbu.$invalid) return;
      }
      this.currentStep++;
    },
    parsePayload(formData = {}) {
      const { invoice, cbu, transactions } = formData;
      const transactionIds = transactions.map((transaction) => transaction.id);
      const form = new FormData();
      form.append("archivo_factura", invoice);
      form.append("transacciones", transactionIds);
      form.append("cbu_field", cbu);
      return form;
    },
    async handleSumbit() {
      this.sendFormLoading = true;
      this.$v.formData.$touch();
      if (this.$v.formData.$invalid) return;
      const data = this.parsePayload(this.formData);

      this.sendInvoice(data)
        .then(() => {
          this.success = true;
          this.hasError = false;
          this.showErrorMessage = false;
        })
        .catch((error) => {
          this.hasError = true;

          if (error.isAxiosError) {
            const { error_code: errorCode } = error.response?.data;
            if (errorCode === WRONG_INVOICE) {
              this.$router.push({ name: "AlternativeFormView" });
            }
            if (errorCode === WRONG_AMOUNTS) {
              this.showErrorMessage = true;
            }
          }

          if (error instanceof Error) {
            console.log(error.message);
          }

          console.log("error handle submit", error);
        })
        .finally(() => {
          this.sendFormLoading = false;
        });
    },
  },
  watch: {
    formData: {
      handler(newValue) {
        this.handleFormDataChanges(newValue);
      },
      deep: true,
    },
    formDataTransactions: {
      handler(newValues) {
        localStorage.setItem("pending-transactions", JSON.stringify(newValues));
      },
      deep: true,
    },
    success(newValue) {
      if (newValue) {
        this.setState();
        localStorage.removeItem("pending-transactions");
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 959px) {
  .left-col {
    width: 100%;
  }
}

@media (min-width: 960px) {
  .left-col {
    width: 65%;
  }
}

.bodypad {
  padding: 12px 24px 50px 24px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 70px);
}
</style>
